import { render, staticRenderFns } from "./FoGrilla.vue?vue&type=template&id=68ce0630&scoped=true&"
import script from "./FoGrilla.vue?vue&type=script&lang=js&"
export * from "./FoGrilla.vue?vue&type=script&lang=js&"
import style0 from "./FoGrilla.vue?vue&type=style&index=0&id=68ce0630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ce0630",
  null
  
)

export default component.exports